module.exports = __webpack_public_path__ + "media/images/blank-ec22eb1653e20c354ea06f86142f169b.jpg";